module.exports = require("react-motion");


/*****************
 ** WEBPACK FOOTER
 ** external "react-motion"
 ** module id = 4
 ** module chunks = 0
 **/